import moment from 'moment';
import { isNaN } from 'lodash';

import { verifyInputFormat } from 'common/util/dateTime';

export function getRawValue(dataType, value) {
    switch (dataType && dataType.toLowerCase()) {
        case 'small_text':
            return value;
        case 'large_text':
            return value;
        case 'dateonly':
            value = moment.utc(value, verifyInputFormat(value));
            value = value.isValid() ? value : moment();
            return value;
        case 'datetime':
            value = moment(value, verifyInputFormat(value));
            value = value.isValid() ? value : moment();
            return value;
        case 'integer':
            return parseInt(value, 10);
        case 'real':
            return parseFloat(value);
        case 'boolean':
            return Boolean(value);
        default:
            return value;
    }
}

export function getStringValue(dataType, value) {
    const rawValue = getRawValue(dataType, value);
    switch (dataType && dataType.toLowerCase()) {
        case 'dateonly':
            return rawValue.format();
        case 'datetime':
            return rawValue.format();
        case 'integer':
            if (isNaN(rawValue)) {
                return '';
            } else {
                return rawValue.toFixed(0);
            }
        case 'real':
            if (isNaN(rawValue)) {
                return '';
            } else {
                return rawValue.toFixed(2);
            }
        case 'boolean':
            return rawValue ? 'Yes' : 'No';
        default:
            return rawValue;
    }
}

export function serializeToStringValue(dataType, value) {
    const rawValue = getRawValue(dataType, value);
    switch (dataType && dataType.toLowerCase()) {
        case 'dateonly':
            return rawValue.toISOString();
        case 'datetime':
            return rawValue.toISOString();
        case 'integer':
            return rawValue.toString();
        case 'read':
            return rawValue.toString();
        case 'boolean':
            return rawValue ? 'true' : 'false';
        default:
            return rawValue;
    }
}

export function getDefaultValue(dataType) {
    switch (dataType && dataType.toLowerCase()) {
        case 'small_text':
            return '';
        case 'large_text':
            return '';
        case 'dateonly':
            return moment();
        case 'datetime':
            return moment();
        case 'integer':
            return 0;
        case 'real':
            return 0;
        case 'boolean':
            return false;
        default:
            return null;
    }
}